import { render, staticRenderFns } from "./projectscene-setting.vue?vue&type=template&id=6d9edaee&scoped=true"
import script from "./projectscene-setting.vue?vue&type=script&lang=js"
export * from "./projectscene-setting.vue?vue&type=script&lang=js"
import style0 from "./projectscene-setting.vue?vue&type=style&index=0&id=6d9edaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9edaee",
  null
  
)

export default component.exports